import $ from 'jquery';

const Login = () => {
  const $videoWrapper = $('#vively-book-video-wrapper');

  // Preventing from execution on non login page
  if ($videoWrapper.length === 0) {
    return;
  }

  const $playButton = $('#vively-book-play-button');
  const $fsButton = $('#vively-book-fs-button');
  const video = $videoWrapper.find('video')[0];

  // Checking if video was found
  if (!video) {
    return;
  }

  // Stopping video
  $videoWrapper.click(() => {
    if ($videoWrapper.hasClass('active')) {
      $videoWrapper.removeClass('active');
      video.pause();
    }
  });

  // Playing video
  $playButton.click((e) => {
    e.stopPropagation();
    if (!$videoWrapper.hasClass('active')) {
      $videoWrapper.addClass('active');
      video.play();
    }
  });

  // eslint-disable-next-line no-alert
  let goFullScreen = () => { alert('Full screen not supported'); };

  if (video.requestFullscreen) {
    goFullScreen = () => { video.requestFullscreen(); };
  } else if (video.mozRequestFullScreen) { /* Firefox */
    goFullScreen = () => { video.mozRequestFullScreen(); };
  } else if (video.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    goFullScreen = () => { video.webkitRequestFullscreen(); };
  } else if (video.msRequestFullscreen) { /* IE/Edge */
    goFullScreen = () => { video.msRequestFullscreen(); };
  }

  // Zooming video
  $fsButton.click((e) => {
    e.stopPropagation();
    goFullScreen();
  });
};

export default Login;



// WEBPACK FOOTER //
// ./login/scripts/main.js